import { useMutation, useQueryClient } from "@tanstack/react-query";
import { resyncForm } from "../services/resync-form";
import { toast } from "@/hooks/use-toast";

export function useResyncForm(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => resyncForm(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["form", id] });
      queryClient.invalidateQueries({ queryKey: ["forms"] });
      toast({ title: "Synced", description: "Form re-fetched from Typeform" });
    },
    onError: (error: any) => {
      toast({
        title: "Error",
        description:
          error.response?.data?.message || "Failed to re-fetch form",
        variant: "destructive",
      });
    },
  });
}
